import * as React from 'react';

import type { WorkOrderReviewHistoryItemVM } from 'ab-viewModels/workOrder/workOrderFieldReportCard.viewModel';

import { WorkOrderReviewStatus } from '@acceligentllc/shared/enums/workOrderReviewStatus';

import { bemElement } from 'af-utils/bem.util';

interface OwnProps {
	workOrderReviewHistoryItem: Nullable<WorkOrderReviewHistoryItemVM>;
}

type Props = OwnProps;

const WorkOrderRejectionReason: React.FC<Props> = (props: Props) => {
	const { workOrderReviewHistoryItem } = props;

	if (!workOrderReviewHistoryItem) {
		return null;
	}

	const status = workOrderReviewHistoryItem.newStatus;
	if (!workOrderReviewHistoryItem.rejectReason || status !== WorkOrderReviewStatus.REJECTED) {
		return null;
	}

	const itemClassName = bemElement('field-report-work-order-info-card__header', 'reject-reason');

	return (
		<div className="field-report-work-order-info-card__header__reject-reason-container">
			<span className="field-report-work-order-info-card__header__reject-title">
				Rejection Reason:
				<span className={itemClassName}>
					{workOrderReviewHistoryItem.rejectReason}
				</span>
			</span>
		</div>
	);
};

export default React.memo(WorkOrderRejectionReason);
